/* eslint-disable react/prop-types */
import React from 'react';
import { Avatar } from 'antd';

import { UserOutlined } from '@ant-design/icons';

function MessageBubble({ content, header, footer, placement = 'start', avatar }) {
  return (
    <div className={`message-bubble message-bubble-${placement}`}>
      {placement === 'start' && (
        <div className="message-bubble-avatar">{avatar || <Avatar icon={<UserOutlined />} />}</div>
      )}

      <div className={`message-bubble-content message-bubble-content-${placement}`}>
        {header && <div className="message-bubble-header">{header}</div>}

        <div className="message-bubble-text">{content}</div>

        {footer && <div className="message-bubble-footer">{footer}</div>}
      </div>

      {placement === 'end' && (
        <div className="message-bubble-avatar">{avatar || <Avatar icon={<UserOutlined />} />}</div>
      )}
    </div>
  );
}

export default MessageBubble;
